import { mdiDownload } from '@mdi/js'
import Icon from '@mdi/react'
import EditIcon from '@mui/icons-material/Edit'
// import Checkbox from '@mui/material/Checkbox'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import CardComposeButton from 'components/Card/CardComposeButton'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import { openComposerContentDialog } from 'services/ui'
import { StoreThunkDispatch } from 'store/state'
import styles from './ChatImageBubble.pcss'

const ICON_SIZE_SM = '16px'

interface ChatImageBubbleProps {
  imageUrl: string
  onCreatePost: (imageUrl: string) => void
  testId?: string
}

export function ChatImageBubble({ imageUrl, onCreatePost, testId }: ChatImageBubbleProps) {
  const dispatch = useDispatch<StoreThunkDispatch>()

  const onEdit = () => {
    dispatch(openComposerContentDialog({ tab: 'edit', imageUrl }))
  }

  const onDownload = () => {
    const a = document.createElement('a')
    a.href = imageUrl
    a.download = `ai-image-${Date.now()}.png`
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <div
      data-testid={testId}
      data-role="assistant"
      data-kind="image"
      className={`${styles.message} ${styles.assistant}`}
    >
      <div className={`${styles.bubble} ${styles['image-bubble']}`}>
        <div className={styles['image-wrapper']}>
          <img
            className={styles['generated-image']}
            src={imageUrl}
            alt="Generated image"
          />
          <div className={styles.overlay}>
            {/* TODO: select checkbox hidden until selection is wired up
            <Checkbox
              size="small"
              className={styles['select-checkbox']}
              onClick={(e) => e.stopPropagation()}
            />
            */}
            <div className={styles['actions-row']}>
              <Tooltip title={<FormattedMessage id="content-card.actions.edit-image" />}>
                <IconButton size="small" className={styles['btn-action']} onClick={onEdit}>
                  <EditIcon className={styles['action-icon']} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Download">
                <IconButton size="small" className={styles['btn-action']} onClick={onDownload}>
                  <Icon path={mdiDownload} size={ICON_SIZE_SM} />
                </IconButton>
              </Tooltip>
            </div>
            <CardComposeButton
              className={styles['compose-btn']}
              onClick={() => onCreatePost(imageUrl)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatImageBubble
